module.exports = __webpack_public_path__ + "img/city3.308ac06c.jpg";